import { Dispatch } from "redux";
import { errorHandler } from "../../helpers/Functions";
import ConfigService from "../../services/ConfigService";

export const fileUpload = (data: FormData, name: string) => {
  const api = new ConfigService().uploadFile(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          if (res.fileName) {
            res.fileType = name;
            dispatch({
              type: "FILE_UPLOAD",
              payload: res,
            });
          } else {
            dispatch({
              type: "ALERT",
              payload: {
                message: errorHandler(res),
                successful: false,
              },
            });
          }
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Network request failed",
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
export const getRegionAction = () => {
  const api = new ConfigService().getRegionService();

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "REGIONS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getRegionStateAction = (data: any) => {
  const api = new ConfigService().getRegionStateService(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.result) {
          dispatch({
            type: "REGIONS_STATE",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getFormStateAction = (data: any) => {
  const api = new ConfigService().getRegionStateService(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.result) {
          dispatch({
            type: "FORM_STATE",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};


export const getLgaAction = (data: any) => {
  const api = new ConfigService().getAreasByState(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.result) {
          dispatch({
            type: "GET_LGA",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};



export const getRegionTerritoryAction = (data: any) => {
  const api = new ConfigService().getRegionTerritoryService(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.result) {
          dispatch({
            type: "REGIONS_TERRITORY",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getOTP = (data: any) => {
  const api = new ConfigService().getOTP(data);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "OTP sent",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getBanks = () => {
  const api = new ConfigService().getBanks();

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "GET_BANKS",
            payload: res,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAgentAccount = (phoneNumber: string) => {
  const api = new ConfigService().getAgentAccount(phoneNumber);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: "AGENT_DETAILS",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              successful: false,
              message: errorHandler(res),
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: "ALERT",
          payload: {
            message: "Network request failed",
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};
